import { API_BASE_URL } from '../client';

export const ALERT_ENDPOINTS = {
  ALERTS: {
    LIST: `${API_BASE_URL}/alerts`,
    UNREAD_COUNT: `${API_BASE_URL}/alerts/unread-count`,
    READ: (id: number) => `${API_BASE_URL}/alerts/${id}/read`,
    READ_BATCH: `${API_BASE_URL}/alerts/read-batch`,
  },
} as const;
